// Legal / Iubenda configuration.
// These are PUBLIC embed IDs/URLs (no secrets). Fill them in frontend/.env
// once the Iubenda account is ready:
//   REACT_APP_IUBENDA_PRIVACY_URL, REACT_APP_IUBENDA_COOKIE_URL,
//   REACT_APP_IUBENDA_SITE_ID, REACT_APP_IUBENDA_COOKIE_POLICY_ID
// The cookie-solution banner script lives in public/index.html and only loads
// once REACT_APP_IUBENDA_SITE_ID is set.

export const COMPANY = {
  legalName: "Zitro Apartments S.r.l.",
  brand: "Zitro Property Management",
  vat: "IT13501380961",
  address: "Via Cinque Giornate 76/L, Cernobbio (CO)",
  email: "info@zitroapartments.com",
};

// Fallback to "#" so links render even before the Iubenda URLs are configured.
export const IUBENDA = {
  privacyUrl: process.env.REACT_APP_IUBENDA_PRIVACY_URL || "#",
  cookieUrl: process.env.REACT_APP_IUBENDA_COOKIE_URL || "#",
};
